// Centralized subject data for all semesters
// Data sourced from ITER Wallah (https://iter-wallah.netlify.app/)

export const semesterSubjects = {
    // First Year - Semester 1
    1: [
        {
            title: 'Universal Physics and Mechanics',
            code: 'UPM',
            description: 'Study of fundamental physics principles, classical mechanics, and their applications in engineering.',
            link: 'https://drive.google.com/drive/folders/1EI_Pr2QIAENS4t4lqdJpRqTYjMejy0co',
            color: 'blue'
        },
        {
            title: 'CALCULUS A',
            code: 'CALC-A',
            description: 'Fundamental calculus concepts including limits, derivatives, and integration techniques.',
            link: 'https://drive.google.com/drive/folders/1qHImcccEFqyRmDV6yBv1oBnMvdo2w07j',
            color: 'purple'
        },
        {
            title: 'Universal Human Values',
            code: 'UHV',
            description: 'Exploration of ethical principles, human values, and their role in personal and professional life.',
            link: 'https://drive.google.com/drive/folders/1w12sn8Q3MZq4SZ-L-2BAiOyI8pfCbHtX',
            color: 'green'
        },
        {
            title: 'Introduction to Computer Programming',
            code: 'ICP',
            description: 'Basics of programming using C language, including syntax, logic building, and problem-solving.',
            link: 'https://drive.google.com/drive/folders/1qDS9s575O8EWHluJklhjwggXTQIjFn6a',
            color: 'cyan'
        },
        {
            title: 'Discrete Mathematics',
            code: 'DM',
            description: 'Mathematical structures and concepts essential for computer science including set theory and logic.',
            link: 'https://drive.google.com/drive/folders/1Ydwgzm-bzsTTMGY8uFfUkUNSUvoOil6q',
            color: 'amber'
        }
    ],

    // First Year - Semester 2
    2: [
        {
            title: 'Universal Physics: Electrics and Mechanics',
            code: 'UPEM',
            description: 'Advanced physics covering electricity, magnetism, and their mechanical applications.',
            link: 'https://drive.google.com/drive/folders/1vWTmv1IFnxzP2iJXpfpyduIYBLU2mkz1',
            color: 'blue'
        },
        {
            title: 'CALCULUS B',
            code: 'CALC-B',
            description: 'Advanced calculus topics including multivariable calculus and differential equations.',
            link: 'https://drive.google.com/drive/folders/1wrg-ZXp36GBcFNBL5Zm7xbje7a2ET0Hc',
            color: 'purple'
        },
        {
            title: 'Introduction to Technical Writing',
            code: 'ITW',
            description: 'Development of technical communication skills including documentation and report writing.',
            link: 'https://drive.google.com/drive/folders/13XNoaqgL8VK6qRnHgdfJfjLUqaoHMKmc',
            color: 'green'
        },
        {
            title: 'Data Structures and Algorithms',
            code: 'DSA',
            description: 'Fundamental data structures and algorithmic techniques for efficient problem-solving.',
            link: 'https://drive.google.com/drive/folders/1FBRMN47L049gPx2C4MVkBXRwUeDjgCUD',
            color: 'cyan'
        },
        {
            title: 'Introduction to Graph Theory',
            code: 'IGT',
            description: 'Study of graphs, trees, networks, and their applications in computer science.',
            link: 'https://drive.google.com/drive/folders/1737Jx4RIWRUGgLKJQgl4Jj4ocXJCb7fc',
            color: 'pink'
        }
    ],

    // Second Year - Semester 3
    3: [
        {
            title: 'Field Programmable Gate Array',
            code: 'FPGA',
            description: 'Third semester FPGA notes covering digital circuit design and FPGA programming fundamentals.',
            link: 'https://drive.google.com/drive/folders/1f2D9jn0kn8mT2GZyD5nWdEaJOwXXi9tF?usp=sharing',
            color: 'blue'
        },
        {
            title: 'Computer Science Workshop - I',
            code: 'CSW-I',
            description: 'Hands-on course introducing web development basics with HTML, CSS, JavaScript, and jQuery.',
            link: 'https://drive.google.com/drive/folders/11y8iBePAW1ailt6rxHpulm5ctrFpFjB2',
            color: 'purple'
        },
        {
            title: 'Probability and Statistics',
            code: 'P&S',
            description: 'Covers probability distributions, statistical analysis, hypothesis testing, and regression analysis.',
            link: 'https://drive.google.com/drive/folders/12N_tI3O0Ul0J7Wqd9ZUzW3dAzwdbhZJa',
            color: 'green'
        },
        {
            title: 'Digital Logic and Design',
            code: 'DLD',
            description: 'Fundamental subject focusing on Boolean algebra, logic gates, and digital circuit design principles.',
            link: 'https://drive.google.com/drive/folders/1UYnyiLal-bwoe28iw6RHyZCmEa9fRi4x',
            color: 'amber'
        },
        {
            title: 'Introduction to Environmental Science',
            code: 'IES',
            description: 'Study of nature, human interaction, pollution, climate change, and environmental protection solutions.',
            link: 'https://drive.google.com/drive/folders/1-7yeL6GxA8DZsdEh0sh-JlLVQxKdPvfr',
            color: 'emerald'
        },
        {
            title: 'Algorithms and Design - I',
            code: 'AD-I',
            description: 'Focuses on algorithm design, analysis, optimization, and problem-solving techniques like dynamic programming.',
            link: 'https://drive.google.com/drive/folders/1cmt1FArJDZ5e0jGJvWN2qxhQ-hpCdKZW',
            color: 'cyan'
        },
        {
            title: 'Introduction to Microeconomics',
            code: 'MICRO',
            description: 'Study of individual and business decision-making regarding supply, demand, prices, and market competition.',
            link: 'https://drive.google.com/drive/folders/1ZY5rPHL44JrilDc-XZZ43F7_NqaWMroP',
            color: 'pink'
        }
    ],

    // Second Year - Semester 4
    4: [
        {
            title: 'Introduction to Artificial Intelligence',
            code: 'AI',
            description: 'Fundamentals of AI including search algorithms, knowledge representation, and intelligent agents.',
            link: 'https://drive.google.com/drive/folders/1kuvQDq39YI6DG_hmejcs4whOhplYD7yw',
            color: 'blue'
        },
        {
            title: 'Machine Learning Workshop - I',
            code: 'MLW-I',
            description: 'Hands-on introduction to machine learning concepts, tools, and practical implementations.',
            link: 'https://drive.google.com/drive/folders/1fSvQ67HCm28t6LN7cZ9Lb8-nKd2d5J64',
            color: 'purple'
        },
        {
            title: 'Computer Science Workshop - II',
            code: 'CSW-II',
            description: 'Advanced web development and software engineering practices with modern frameworks.',
            link: 'https://drive.google.com/drive/folders/1Q4ssemkq7RWy4mgZtxm0roydqdVD9tjS',
            color: 'green'
        },
        {
            title: 'Applied Linear Algebra',
            code: 'ALA',
            description: 'Linear algebra concepts and their applications in computer graphics, ML, and data science.',
            link: 'https://drive.google.com/drive/folders/1S4fMwpVETQ_3hjIfh47pl4LSicZprFAm',
            color: 'cyan'
        },
        {
            title: 'Computer Organisation & Architecture',
            code: 'COA',
            description: 'Study of computer hardware organization, processor design, and memory management.',
            link: 'https://drive.google.com/drive/folders/1UYnyiLal-bwoe28iw6RHyZCmEa9fRi4x',
            color: 'amber'
        },
        {
            title: 'Introduction to Disaster Management',
            code: 'IDM',
            description: 'Understanding disaster preparedness, mitigation strategies, and emergency response systems.',
            link: 'https://drive.google.com/drive/folders/1-7yeL6GxA8DZsdEh0sh-JlLVQxKdPvfr',
            color: 'emerald'
        },
        {
            title: 'Algorithms and Design - II',
            code: 'AD-II',
            description: 'Advanced algorithmic techniques including graph algorithms, greedy algorithms, and complexity theory.',
            link: 'https://drive.google.com/drive/folders/1KcT-lVag-kV5OpZA_dxT4JTRcPaIxDn6',
            color: 'pink'
        }
    ],

    // Third Year - Semester 5
    5: [
        {
            title: 'Practical Programming with C',
            code: 'PPC',
            description: 'Advanced C programming focusing on system-level programming and practical applications.',
            link: 'https://drive.google.com/drive/folders/10Rz8FR5mP1o9HH-MdmZnSJsed_7ZvnCT',
            color: 'blue'
        },
        {
            title: 'Design of Operating System',
            code: 'DOS',
            description: 'Operating system design principles, process management, scheduling, and memory management.',
            link: 'https://drive.google.com/drive/folders/1TANZsdRdsNAXTqJvjTI2gFY6h6kbbmtW',
            color: 'purple'
        },
        {
            title: 'Computer Networking: Concepts',
            code: 'CN-C',
            description: 'Fundamental networking concepts including protocols, routing, and network architecture.',
            link: 'https://drive.google.com/drive/folders/1ffp0UK0i4G8pD1mKjPIC6EOufPs2GQHb',
            color: 'green'
        },
        {
            title: 'Python Programming',
            code: 'PYTHON',
            description: 'Comprehensive Python programming covering syntax, libraries, and real-world applications.',
            link: 'https://drive.google.com/drive/folders/1x81F5_NGrNutR7u8NTW4kKg7UftAL5GA',
            color: 'cyan'
        },
        {
            title: 'Introduction to Theory of Computation',
            code: 'TOC',
            description: 'Study of computational models, automata theory, formal languages, and computability.',
            link: 'https://drive.google.com/drive/folders/14Vd4nADRgnRLJU_DrpYIuq3rETIGj3YY',
            color: 'amber'
        },
        {
            title: 'Foundation of Machine Learning',
            code: 'FML',
            description: 'Core machine learning algorithms, supervised and unsupervised learning techniques.',
            link: 'https://drive.google.com/drive/folders/1cmt1FArJDZ5e0jGJvWN2qxhQ-hpCdKZW',
            color: 'pink'
        }
    ],

    // Third Year - Semester 6
    6: [
        {
            title: 'Game Programming with C++',
            code: 'GP-CPP',
            description: 'Game development fundamentals using C++, graphics programming, and game engine concepts.',
            link: 'https://drive.google.com/drive/folders/1cmt1FArJDZ5e0jGJvWN2qxhQ-hpCdKZW',
            color: 'blue'
        },
        {
            title: 'Introduction to Databases',
            code: 'IDB',
            description: 'Database design, SQL, normalization, transaction management, and database administration.',
            link: 'https://drive.google.com/drive/folders/13uZPTMbGcSqpIRCabrusaQ07ECwR-zrF',
            color: 'purple'
        },
        {
            title: 'Computer Networking: Security',
            code: 'CN-S',
            description: 'Network security principles, cryptography, firewalls, and secure communication protocols.',
            link: 'https://drive.google.com/drive/folders/1h54x1_TMzOGv9vC9B8eF0GbPLi-Umkff',
            color: 'green'
        },
        {
            title: 'Compilers: Principles, Techniques and Tools',
            code: 'COMPILER',
            description: 'Compiler design including lexical analysis, parsing, code generation, and optimization.',
            link: 'https://drive.google.com/drive/folders/1R9ljdlD8LZNLqsOWcsaZaBlTncTeAmnX',
            color: 'cyan'
        }
    ],

    // Fourth Year - Semester 7 (Coming Soon)
    7: [],

    // Fourth Year - Semester 8 (Coming Soon)
    8: []
};

// Helper function to get year name
export const getYearName = (year) => {
    const yearNames = {
        1: 'First',
        2: 'Second',
        3: 'Third',
        4: 'Fourth'
    };
    return yearNames[year] || 'First';
};

// Helper function to extract academic year from registration number
export const getAcademicYear = (regno) => {
    if (!regno || regno.length < 2) return 1;

    const yearPrefix = parseInt(regno.substring(0, 2));
    const currentYear = new Date().getFullYear() % 100; // Get last 2 digits of current year

    // Calculate year (26 - 24 = 2 for 2nd year, 26 - 25 = 1 for 1st year, etc.)
    const year = currentYear - yearPrefix;

    // Clamp between 1 and 4
    return Math.max(1, Math.min(4, year));
};

// Helper function to get semesters for a given year
export const getSemestersForYear = (year) => {
    const semesterMap = {
        1: [1, 2],
        2: [3, 4],
        3: [5, 6],
        4: [7, 8]
    };
    return semesterMap[year] || [1, 2];
};

// Helper function to get all subjects for a student's year
export const getSubjectsForYear = (year) => {
    const semesters = getSemestersForYear(year);
    return semesters.flatMap(sem => semesterSubjects[sem] || []);
};
